import React from "react";
import "./ImageSideIQComponent.scss";
import Frame1_iq from "../../assets/icons/iq-img1.png";
import Frame2_iq from "../../assets/icons/iq-img2.png";
import Frame3_iq from "../../assets/icons/iq-img3.png";

const ImageSideIQComponent = () => {
  return (
    <div className="image-side-section-iq">
      <div className="img-side-left-iq frame1-iq">
        <img src={Frame1_iq} alt={"Frame1"} className="image-left-iq" />
        <div className="content-iq">
          <h3 className="headline-h3-iq">Find aircraft that are ‘mission ready’ at your fingertips</h3>
          <p className="w330 body-font-p-iq">
          We provides 24/7 Data Operations Team for operators, allowing both operators and their customers access to a 'vetted and efficient, marketplace.
          </p>
        </div>
      </div>
      <div className="img-side-right-iq frame2-iq">
        <div className="content-iq">
          <h3 className="headline-h3-iq">Save booking acquisition time by 75%+</h3>
          <p className="w422-iq body-font-p-iq">
          Show your charter clients your self-branded app and booking widget in order to streamline the booking process for all.
          </p>
        </div>
        <img src={Frame2_iq} alt={"Frame2-iq"} className="image-right-iq" />
      </div>
      <div className="img-side-left-iq frame3-iq">
        <img src={Frame3_iq} alt={"Frame3"} className="image-left-iq" />
        <div className="content-iq">
          <h3 className="headline-h3-iq">Market Your entire Fleet at Low Upfront Costs</h3>
          <p className="w330 body-font-p-iq">
          Show the marketplace your entire fleet at a 'fixed subscription cost' vs. today's existing offerings, and pay when a mission happens, not before.  Plus, our 'White Labeled" Market Analytic Reports are at your fingertips in real-time, enabling your team to secure more bookings.
          </p>
        </div>
      </div>
      
    </div>
  );
};

export default ImageSideIQComponent;
